window.Import = {
	table		: null,
	pasted		: '',
	db			: null,
	importTypes : [],
	
	/**
	 * Setup Papaparse configuration.
	 * 
	 * @param {Object} extendedConfiguration
	 * @return {Object}
	 */
	setupConfiguration : function (extendedConfiguration) {

		return {
			config : Object.assign({

				delimiter		: '',
				newline			: '',
				header			: false,
				quotes			: true,
				skipEmptyLines	: true,
				encoding		: $('select[name=import_encoding]').val()
	
			}, extendedConfiguration)
		};
	},

	initOverview : function(){
		MyTabs.initVertical('importTabs');
	},
	
	loadLineLogTab : function(importid){
		if($('#content_log').html() === ''){
			var options = {
				action		: "loadListingTab",
				importid	: importid,
				listing		: 'importlog'
			};

			MyFacture.post('import', options, function (data) {
				$('#content_log').html(data.listing);
				
				Listing.init(data.prefix);
				var options = {
					data : {
						action		: 'updateListingTab',
						importid	: importid,
						listing		: 'importlog'
					},
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
						Import.logTips();
					},
					dataType: "json"
				};
				
				
				MyForm.prepare(data.listingname + "FilterForm", "import", options);

				MyFacture.customForm('#content_log');
				Import.logTips();
			}, 'json');
		}
	},
	
	startWait : function(){
		$('#importMask').appendTo('body');
		$('#importMask').css({'top':$(window).scrollTop()});
        $('#importMask ul').css({'margin-top':$(window).scrollTop()+300});
        $('#importMask').fadeIn();
	},
	
	stopWait : function(){
        $('#importMask').fadeOut('fast', function(){
			$('#importMask').find('li').removeAttr('class');
		});
	},
	
	stepWait : function(stepname, step){
        $('#importMask').find('#step-'+stepname).removeAttr('class').addClass(step);
		if(step == 'done'){
			$('#importMask').find('#step-'+stepname).next('li').removeAttr('class').addClass('inprogress');
		}
	},
	
	create : function(type = null, legacyEntryPoint = true){
		
		var formID	= 'proposalCreateForm';
		
		var data	= {
			action :'createForm',
			legacyEntryPoint: legacyEntryPoint
		};
		const importTypeLabel = {
			individual: Loc.g("particuliers"),
			people: Loc.g("contacts"),
			corporation: Loc.g('sociétés'),
		}
		var options = {
			title: `${Loc.g("Importer des données")} ${importTypeLabel[type] ?? ''}`,
			buttons: [
				{
					"class"	: "btn btn-default",
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					"class"	: "btn btn-primary",
					text	: Loc.g("Continuer"),
					click	: function () {
						var importType = $('input[name=import_type]').val();
						
						if(importType !== ''){
							Utils.relocate('/?_f=import&action=setupForm&type='+importType+'&legacyEntryPoint='+legacyEntryPoint);
						}else{
							MyWindow.alert(Loc.g('Veuillez choisir le type d‘import à réaliser'), {type : 'warning'});
						}
					}
				}
			],
			width: 1200,
			height: 650,
			callback: function () {
				if(type) {
					Import.chooseType(type, data.legacyEntryPoint);
				} else {
					$('.ui-dialog-buttonpane').hide();
					$('#popupWindow').css('overflow-y', 'hidden');
				}
			}
		};
		
		MyWindow.load('import', data, options);
	},
	
	chooseType : function(type, legacyEntryPoint = true){
		var alreadyrunning = $('#import_'+type).data('alreadyrunning');
		
		if(alreadyrunning){
			
			var buttons = [
				{
					"class"		: "btn btn-default",
					text		: Loc.g("Annuler"),
					click		: function () {
						$(this).dialog("close");
					}
				}
			];
		}else{
			var buttons = [
				{
					"class"	: "btn btn-default",
					text	: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					"class"	: "btn btn-primary",
					text	: Loc.g("Continuer"),
					click	: function () {
						var importType = $('input[name=import_type]').val();
						
						if(importType !== ''){
							Utils.relocate('/?_f=import&action=setupForm&type='+importType+'&legacyEntryPoint='+legacyEntryPoint);
						}else{
							MyWindow.alert(Loc.g('Veuillez choisir le type d‘import à réaliser'), {type : 'warning'});
						}
					}
				}
			];
		}
		
		MyWindow.addOption('buttons', buttons);
		
		$.ajax({
			url			: '/?_f=import',
			data		: {action : 'getAvailableData', importType : type},
			dataType	: 'json',
			type		: 'POST',
			beforeSend	: function(){
				if(legacyEntryPoint) {
					var $preloader = $('<div class="ajax_preloader"><i class="fa fa-circle-o-notch fa-spin"></i><p>'+Loc.g('Chargement...')+'</p></div>');
					$preloader.appendTo($('#fileFormatFieldset'));
					$('#fileFormatFieldset #import_alreadyrunning:visible').hide();

				}
			},
			success		: function(data){
				$('.placeholder').hide();
				
				if(data.error !== undefined){
					$('.fileFormat').html('<div class="placeholder">'+data.error.message+'</div>');
					$('#fileFormatFieldset #import_hint:visible').hide();
					$('input[name=import_type]').val('');
				}else{

					$('.fileFormat').html(data.availableFields);
					$('#fileFormatFieldset #import_hint:hidden').show();
					
					if(alreadyrunning){
						$('#fileFormatFieldset #import_alreadyrunning:hidden').show();
					}
					
					$('input[name=import_type]').val(type);
					$('#templateDownload').attr('href', '/?_f=import&action=downloadTemplate&importType='+type);
				}
				
				$('li.import').removeClass('current');
				$('li#import_'+type).addClass('current');
				
				$('.ajax_preloader').fadeOut('fast', function(){
					$(this).remove();
				});
			}
		});
	},
	
	adjustHeight : function(){
		$('#import_settings, #import_uploader').css('height', 'auto');
		var maxHeight = Math.max(300, $('#import_settings').height(), $('#import_uploader').height());
		
		$('#import_uploader').height(maxHeight);
		$('#import_settings').height(maxHeight);
	},
	
	initSetupForm : function(){
		var formID = 'importSetupForm';
		
		MyTabs.initHorizontal("import_uploader",{
			callback : function(itm){
				var tabId = $(itm).attr('id');
				$('input[name=import_method]').val(tabId);
			}
		});
		
		Import.adjustHeight();

		// affiche un retour visuel dès que input:file change
		$("#import_csv").on( "change", function( event ) { 
			
			var filepath	= $(this).val();
			var filename	= filepath.replace(/C:\\fakepath\\/, '', 'g');
			// Check Extension
			var fileParts	= filename.split('.');
			
			if(fileParts.length > 0 && fileParts[(fileParts.length - 1)] === 'csv'){
				
				$('.input-filename').html(filename);  
				$('input[name=filename]').val(filepath);  

				Import.analyzeCSV();
			}else{
				MyWindow.alert(Loc.g('Le format de votre fichier est invalide. Format autorisé : CSV.'), {type : 'warning'});
			}
			
			
		});
		
		
		var options = {
			data		: {action : 'record'},
			dataType	: "json",
			beforeSend	: function(){
				Import.startWait();
				$('#'+formID+' :input').removeClass('ui-state-error');
				$('#'+formID+' :input').removeClass('hidden');
				$('#'+formID+' .alert-danger').hide();
				Import.stepWait('settings', 'inprogress');
			},
			success		: function(data){
				
				var formIsOk = MyForm.processJson(data, formID);
				
				if(!formIsOk){
					Import.stopWait();
					if(data.form.fields !== undefined){
						for(var i in data.form.fields){
							if(data.form.fields[i].fieldId === 'import_csvcol'){
								$('#csv_preview legend .alert-danger').remove();
								$('#csv_preview legend').after('<div class="alert alert-danger" style="border: solid 4px #F67D8C;padding: 16px 24px;font-size: 14px;">'+data.form.fields[i].msg+'</div>');
							}
						}
					}
					$('body').scrollTop(0);
				}else{
					Import.stepWait('settings', 'done');
					// start to transfer data
					Import.sendData(data.id);
				}
			}
		};
		MyForm.prepare(formID, 'import', options, false);
		
		
		$(document).on('change', '.columnSelector', function () {
			Import.updateColumnMatching($(this));
			Import.updateColumnRecognition();
		});

		$('#csv_table_wrapper').width($('#contentDiv').width() - 20);
		$(window).resize(function () {
			$('#csv_table_wrapper').width($('#contentDiv').width() - 20);
		});
	},
	
	updateColumnMatching : function(elt){
		$('.nbColumns').html($('.columnSelector').length);
		$('.nbColumnsMatched').html($('.columnSelector option:selected[value!=""]').length);
		
		var val			= elt.val();
		var oldval		= elt.data('oldval');
		var dataType	= elt.data('type');
		var $th			= elt.closest('th');
		
		if (val === 'none'){
			$th.addClass('lightgrey-bkg grey').removeClass('success-50-bkg');
		} else if (val !== ''){
			$th.addClass('success-50-bkg').removeClass('lightgrey-bkg grey');
		} else{
			$th.removeClass('lightgrey-bkg grey').removeClass('success-50-bkg');
		}	
		
		var $colselector = $('.columnSelector');
		
		$('.colreferences select option[value="' + val + '"]').prop('disabled', false);
		$('.colreferences select option[value="' + oldval + '"]').prop('disabled', true);
		$colselector.not(elt).find('option[value="' + val + '"]').not('[value=none]').not("[value='']").prop('disabled', true);
		$colselector.find('option[value="' + oldval + '"]').not('[value=none]').not("[value='']").prop('disabled', false);
		
		
		elt.data('oldval', val);
		
	},
	
	updateColumnRecognition : function(){
		var importTypes = [];
//		$('.colreferences select option').prop('disabled', true);
		$('.columnSelector').find('option:selected').each(function () {
			
			var val			= $(this).attr('value');
			var dataType	= $(this).data('type');
			
			if (dataType != undefined && dataType != "" && $.inArray(dataType, importTypes) == -1) {
				importTypes.push(dataType);
			}

			$('.colreferences select option[value="' + val + '"]').prop('disabled', false);
			$('.colreferences select').val(val);
		});
		
		$('.colreferences select option:disabled').prop('selected', true);
		$('.colreferences select').multipleSelect({
			selectAll		: false,
			countSelected	: false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés')
		});

		$('.colreferences').hide();

		for (var i in importTypes) {
			$('#colref_' + importTypes[i]).show();
		}

		Import.adjustHeight();
	},
	
	
	massCheckColumns : function(){
		
		var $colSelector = $('.columnSelector option:selected[value=""]');
		
		$colSelector.closest('th').addClass('lightgrey-bkg grey');
		$colSelector.closest('select').val('none');
		$colSelector.closest('select  option:selected[value="none"]').prop('selected',true); 
//		$colSelector.prop('selected', true);
		
		$('.nbColumns').html($('.columnSelector').length);
		$('.nbColumnsMatched').html($('.columnSelector option:selected[value!=""]').length);
		Import.updateColumnRecognition();
	},

	sendData : function(importid){

        Papa.LocalChunkSize = 50 * 512 * 2;

		var papaparseConfig = Import.setupConfiguration({

			error: function (err, file, inputElem, reason) {

				// executed if an error occurs while loading the file,
				// or if before callback aborted for some reason
				console.log('There was an error', err);
            },

			complete: function (results, file) {

                if(results && results.meta.aborted) {
                    Import.onError();
                    Import.stopWait();
                    return;
                }

				Import.stepWait('upload', 'done');

				var length = results;
				$.ajax({
					url			: '/?_f=import',
					type		: 'POST',
					data		: {action : 'checkImport', importid : importid, nbRecords : length},
					dataType	: 'json',
					success		: function(data){
						
						Import.stepWait('check', 'done');
						
						if(!data.completeFile){
                            Import.onError();
						}else{
							Utils.relocate('/settings/imports#importAnchor');
						}
						
						Import.stopWait();
					}
				});

			},

			/**
			 * If a chunk is not valid, returns false to stop parsing current file.
			 * 
			 * @param {Object} results 
			 * @param {ParserHandle} parser 
			 * @return {boolean}
			 */
			chunk : function(results, parser){

				var isValid;

				$.ajax({
					url			: '/?_f=import',
					type		: 'POST', 
					async		: false,
					data		: {
						action		: "storeImportData",
						importid	: importid, 
						data		: results.data
					},
					dataType 	: 'json',
					success 	: function(response){
                        isValid = MyForm.processJson(response);
                    },
                    error       : function(){
                        isValid = false;
                    }
				});

                if(!isValid){
                    parser.abort();
                }
            }

		});

		switch($('#import_method').val()){
			case 'paste' : 
				if(Import.pasted === ''){
					MyWindow.alert(Loc.g('Veuillez copier / coller des données dans la zone de texte'), {type : 'warning'});
				}else{
					papaparseConfig.config.encoding = "";
					Papa.parse(Import.pasted, papaparseConfig.config);
				}
				break;
			case 'file' : 
				if($('input[type=file]').val() === ''){
					MyWindow.alert(Loc.g('Veuillez sélectionner un fichier ci-dessus'), {type : 'warning'});
				}else{
					$('input[type=file]').parse(papaparseConfig);
				}
				break;
		}
	},

    onError: function(){

        var error_string = Loc.g('Votre fichier comporte des erreurs') + ". " + Loc.g('Veuillez vérifier les points suivants') + " :<br><br>"
        + "- " + Loc.g("Chaque colonne de chaque ligne ne doit pas contenir plus de 250 caractères") + "<br>"
        + "- " + Loc.g("L'encodage du fichier doit correspondre à l'encodage sélectionné lors de l'import") + "<br>"
		+ "- " + Loc.g("Le fichier d’import ou votre copier/coller contient trop de lignes.");

        MyWindow.alert(
            error_string,
            {
                type : 'error'
            }
        );
    },

	submitForm : function(){
		var formID = 'importSetupForm';
		$('#csv_table').find('thead select').attr('name', '');
		
		switch($('#import_method').val()){
			case 'paste' : 

				if(Import.pasted === ''){
					MyWindow.alert(Loc.g('Veuillez copier / coller des données dans la zone de texte'), {type : 'warning'});
					return false;
				}
				break;
			case 'file' : 
				if($('#filename').val() === ''){
					MyWindow.alert(Loc.g('Veuillez sélectionner un fichier à importer'), {type : 'warning'});
					return false;
				}
				break;
		}
		
		MyWindow.alert(Loc.g("Vous venez de valider la configuration de votre import. Votre demande sera placée dans une liste d‘attente et sera traitée sous peu.")+"<br /><br />"+Loc.g("Veuillez valider pour procéder à l'import de vos données."), 
			{
				title : Loc.g("Validation de votre import"),
				width : 450,
				buttons : [
					{
						html	: Loc.g("Annuler"),
						click	: function(){
							$(this).dialog('close');
						}
					},
					{
						html	: Loc.g('Valider'),
						click	: function(){
							$(this).dialog('close');
							$('#'+formID).submit();
						}
					}
				]
			}
		);

	},
	
	analyzeCSV : function(){

		var papaparseConfig = Import.setupConfiguration({
			error: function (err, file, inputElem, reason) {
				// executed if an error occurs while loading the file,
				// or if before callback aborted for some reason
				MyWindow.alert(Loc.g("Votre ficher comporte des erreurs de formattage."), {type : "warning"});
			},
			complete: function (results, file) {
				$('textarea#import_paste').val("");
				Import.parseCallback(results, file);
			}
		});
		
		switch($('#import_method').val()){
			case 'paste' : 
				if($('textarea#import_paste').val() === ''){
					MyWindow.alert(Loc.g('Veuillez copier / coller des données dans la zone de texte'), {type : 'warning'});
				}else{
					$('.btn-parse .fa').addClass('fa-spin');
					MyFacture.startWait();
					papaparseConfig.config.encoding	= '';
					
					Import.pasted = $('textarea#import_paste').val();
					Papa.parse(Import.pasted, papaparseConfig.config);
				}
				break;
			case 'file' : 
				if($('input[type=file]').val() === ''){
					MyWindow.alert(Loc.g('Veuillez sélectionner un fichier ci-dessus'), {type : 'warning'});
				}else{
					$('.btn-parse .fa').addClass('fa-spin');
					MyFacture.startWait();
					$('input[type=file]').parse(papaparseConfig);
				}
				break;
		}
	},
	
	parseCallback : function(results, file) {
		
		if(Import.table !== null){
			Import.table.fnDestroy();
			Import.table = null;
			$('#csv_table').empty();
		}
		
		if(results.data.length > $('#import_nbMaxLines').val()){
			MyWindow.alert(Loc.g("Le fichier dépasse le nombre maximal de lignes autorisé")+" ("+$('#import_nbMaxLines').val()+" "+Loc.g("lignes maximum")+")", {type : 'error'});
			
			$('input[name=filename]').val('');  
			$('.input-filename').empty();  

			MyFacture.stopWait();
			$('.btn-parse .fa').removeClass('fa-spin');
			$('#csv_preview .placeholder:hidden').show();
			$('#csv_preview #column-matching:visible').hide();
			
			return;
		}
		
		$('#import_nbRecords').val(results.data.length);
		
		Import.data = results.data;
		
		
		if (results.data.length > 0) {
			
			var regexpList	= [];
			
			$('#repo-fields select').find('option').each(function(){
				if($(this).data('regex') !== ''){
					regexpList[$(this).attr('value')] = new RegExp($(this).data('regex'), 'ig'); 
				}
			});
			

			var dataHeader	= results.data[0];
			var header		= [];
			var hasHeader	= $('#import_hasHeader').val();

			for (var i = 0; i < dataHeader.length; i++) {
				
				var headerValue = ""+dataHeader[i];
				var $select		= $('#repo-fields select').clone();

				$select.find('option').removeAttr('data-regex');

				if(hasHeader === 'Y'){
					for(var j in regexpList){
						if(headerValue !== "" && regexpList[j].test(headerValue)){
							$select.find('option').removeAttr('selected');
							$select.find('option[value="'+j+'"]').attr('selected', true);
							delete regexpList[j];
							break;
						}
					}
				}
				
				header.push({title: '<select name="import_csvcol[]" class="columnSelector" id="import_csvcol_' + i + '">' + $select.html() + '</select>'});
			}
			
			$.fn.dataTable.ext.errMode = 'none';
			
			Import.table = $('#csv_table').on( 'error.dt', function ( e, settings, techNote, message ) {
					
					$('#csv_table').data('error', 'Y');
					
				}).on( 'init.dt', function ( e, settings, techNote, message ) {
					if($('#csv_table').data('error') === 'Y'){

//						$('#csv_table').fnDestroy();
						$('#csv_table_wrapper').remove();
					
						if($('#csv_preview #csv_table').length === 0){
							$('#csv_preview').append('<table id="csv_table" width=""></table>');
						}
						
						Import.table = null;
						
						MyWindow.alert(Loc.g('Votre Fichier comporte des erreurs de formatage.'), {type : 'warning'});
						$('#csv_table').data('error', 'N');
					}else{
						$('.dataTables_scrollBody #csv_table thead select').removeAttr('id').removeAttr('class').removeAttr('name').data('type', '');
						$('.btn-parse .fa').removeClass('fa-spin');

						$('#csv_preview .placeholder:visible').hide();
						$('#csv_preview #column-matching:hidden').show();

						Import.updateColumnRecognition();
						Import.adjustHeight();
						
						$('.dataTables_scrollHead select').each(function(){
							Import.updateColumnMatching($(this));
						});
						Import.updateColumnRecognition();
					}
					
					MyFacture.stopWait();
					
//					return false;
				}).dataTable({
				data			: results.data,
				columns			: header,
				scrollX			: '100%',
//				paging			: false,
				bSort			: false,
				language		: {	
				"sProcessing":		   Loc.g("Traitement en cours..."),
					"sSearch":         Loc.g("Rechercher :"),
					"sLengthMenu":     Loc.g("Afficher _MENU_ éléments"),
					"sInfo":           Loc.g("Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments"),
					"sInfoEmpty":      Loc.g("Affichage de l'élément 0 à 0 sur 0 élément"),
					"sInfoFiltered":   Loc.g("(filtré de _MAX_ éléments au total)"),
					"sInfoPostFix":    "",
					"sLoadingRecords": Loc.g("Chargement en cours..."),
					"sZeroRecords":    Loc.g("Aucun élément &agrave; afficher"),
					"sEmptyTable":     Loc.g("Aucune donnée disponible dans le tableau"),
					"oPaginate": {
						"sFirst":      "<<",
						"sPrevious":   "<",
						"sNext":       ">",
						"sLast":       ">>"
					},
					"oAria": {
						"sSortAscending":  ": "+Loc.g("activer pour trier la colonne par ordre croissant"),
						"sSortDescending": ": "+Loc.g("activer pour trier la colonne par ordre décroissant")
					}
				},
				drawCallback	: function (settings, data) {
					$('#csv_table_wrapper').width($('#contentDiv').width() - 20);
//					// NOT WORKING
					$('.dataTables_scrollBody #csv_table thead select').remove();
//					
				}
			});
		}	
	},
	
	updateColumnMatchingColor : function(elt){
		var val	= elt.val();
		var $th = elt.closest('th');
		
		if (val === 'none'){
			$th.addClass('lightgrey-bkg grey').removeClass('success-50-bkg');
		} else if (val !== ''){
			$th.addClass('success-50-bkg').removeClass('lightgrey-bkg grey');
		} else{
			$th.removeClass('lightgrey-bkg grey').removeClass('success-50-bkg');
		}
	},
	
	init: function(type, legacyEntryPoint = true){
		
		var toRedirect = false;
		var urlValid = '';

		$.ajax({
			
			url			: MyFacture.buildUrl('import'),
			type		: 'POST',
			async		: false,
			dataType	: 'json',
			data		: {
				action	: 'checkAutoLoad'
			},
			
			success : function(data){
				
				toRedirect = true;
				
				var success = data.success;
				urlValid = success.url+'/index.php?autolog=Y&lang=' + success.lang + '&oauth_token=' + success.token + '&oauth_secret=' + success.secret;

				//we have to disctinct and redirect import home if type is annot cause we dont know what third type client want to import
				if(type !== 'annots') {
					urlValid += '&c=' + type;
				}
				if(legacyEntryPoint) {
					MyWindow.alert(Loc.g("Dans quelques instants vous allez être redirigé vers la plateforme d’import") + "<br /> <img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />" + Loc.g("Si rien ne se passe") + " <a target='_blank' style='color:#229EE6;font-weight:bold' href='" + urlValid + "'> " + Loc.g("cliquer ici") + "</a> ", { type: "confirm" });
				} 
				
			}
		});
		
		if(toRedirect){
			window.open(urlValid);
		}
	},
	
	logTips : function(){
		
		$("[tip_type=nbChanges]").each(function(){
			var relatedId	= $(this).attr('tip_relid');
			$(this).qtip({
				style : {
					classes: 'qtip-custom qtip-rich',
					def		: false,
					tip: {
						corner: false
					}
				},
				position: {
					viewport: true,
					my: 'right top',
					at: 'left center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content:{
					ajax: {
						url: '/?_f=import', 
						type: 'GET',
						data: {
							action	: 'qtipLog', 
							logid : relatedId
						},
						once: true
					}
				}
			});
		});
	},
	
	detailChanges : function(logID){
		
		var data	= {
			action : 'detailsLineLogChanges',
			logID  : logID
		};
		
		var options = {
			title	: Loc.g("Détails modifications"),
			buttons	: [
				{
					text: Loc.g("Fermer"),
					click: function () {
						$(this).dialog("close");
					}
				}
			],
			width	: 1200,
			callback: function () {
				
				
			}
		};
		
		MyWindow.load('import', data, options);
	},
	
	
	revert : function(importID){
		
		var msg = Loc.g("Vous souhaitez annuler les modifications de l‘import.");
		msg += '<ul>'
			+ '	<li>'+Loc.g("Les données créés via l‘import seront supprimées")+'</li>'
			+ '	<li>'+Loc.g("Les données mises à jour via l‘import seront rétablies dans leur état d'origine")+'</li>'
			+ '</ul>'
			+ '<p>'+Loc.g('Voulez-vous continuer ?')+'</p>';
	
		MyWindow.alert(msg,
			{
				type	: 'warning',
				buttons : [
					{
						text	: Loc.g('Non'), 
						click	: function(){
							$(this).dialog('close');
						}
					},
					{
						text	: Loc.g('Oui'), 
						click	: function(){
							MyFacture.post(
								'import', 
								{
									action : 'revertImport', 
									importID : importID
								},
								function(data){
									if(data.status === 'ok'){
										MyWindow.alert(
											Loc.g('L‘annulation de votre import a bien été programmée.<br />Nous vous informerons quand les données seront rétablies dans votre compte.'),
											{
												type	: 'success',
												buttons : [{
													html	: Loc.g('Fermer'),
													class	: 'btn btn-default',
													click	: function() { Utils.reload(); }
												}]
											}
										);
									}else{
										MyWindow.alert(data.message, {type : 'error'});
									}
										
								},
								'json'
							);
						}
					}
				]
			}
		);
	},
	
	cancelOne : function(importID){
		
		var msg = Loc.g("Souhaitez-vous vraiment annuler l‘import ?");
	
		MyWindow.alert(msg,
			{
				type	: 'warning',
				buttons : [
					{
						text	: Loc.g('Non'), 
						click	: function(){
							$(this).dialog('close');
						}
					},
					{
						text	: Loc.g('Oui'), 
						click	: function(){
							MyFacture.post(
								'import', 
								{
									action : 'cancelImport', 
									importID : importID
								},
								function(data){
									if(data.status === 'ok'){
										MyWindow.alert(
											Loc.g('Votre import a bien été annulé et ne sera donc pas traité.'), 
											{
												type : 'success',
												buttons : [
													{
														text	: Loc.g('Fermer'),
														'class' : 'btn btn-default',
														click	: function(){
															Utils.reload();
														}
													}
												]
											}
										);
									}else{
										MyWindow.alert(data.message, {type : 'error'});
									}
								},
								'json'
							);
						}
					}
				]
			}
		);
	},
};

window.Imports = {
	prepareFilterForm: function (listingname) {
		
		var options = {
			success	: function (data) {
				Imports.processFilterForm(data, listingname);
			}, 
			dataType: "json"
		};
		
		MyForm.prepare(listingname + 'FilterForm', '/imports', options, undefined, undefined, false);
	},
	
	processFilterForm: function (data, listingname) {
		
		Listing.refresh(listingname+"Listing", data, eval('data.'+data.metadatasName));
	}	
};
